export const ensureDispositionSectionFlag = (sections) => {
    for (const section of sections) {
        section.dispositionSection ??= false;
        if (section.subSections?.length)
            ensureDispositionSectionFlag(section.subSections);
    }
};
//# sourceMappingURL=utils.js.map